export { AuthProvider, useAuth, useRequireAuth } from "@/lib/auth/context";
export type { ActivityCounts, LoginModalPrefill } from "@/lib/auth/context";
export {
  JUST_LOGGED_IN_KEY,
  AUTH_REDIRECT_PATH_KEY,
  CLAIM_RESULT_COOKIE,
  CHAT_CLAIM_RESULT_KEY,
} from "@/lib/auth/constants";
export { isAnonymousUser } from "@/lib/auth/user";
